import React, {Component} from 'react';
import LoadScreen from './LoadScreen';
import IntroScreen from './IntroScreen';
import GameScreen from './GameScreen';
import posed, {PoseGroup} from 'react-pose';
import * as debug from './debug';

const AnimationBox = posed.div();

const screens = {
    load: LoadScreen,
    intro: IntroScreen,
    game: GameScreen,
};

export default class App extends Component {
    state = {
        game: {
            loaded: false,
            started: false,
        },
    };

    constructor(props) {
        super(props);
        debug.setAppSetState(this.setState.bind(this));
    }

    getRoute() {
        const {game} = this.state;

        if (!game.loaded) {
            return 'load';
        }
        if (!game.started) {
            return 'intro';
        }
        return 'game';
    }

    render() {
        const {game} = this.state;

        const route = this.getRoute();
        const Screen = screens[route];

        if (!Screen) {
            return null;
        }

        return (
            <PoseGroup flipMove={false}>
                <AnimationBox key={route}>
                    <Screen game={game} onChangeGame={this.handleChangeGame} />
                </AnimationBox>
            </PoseGroup>
        );
    }

    handleChangeGame = nextGame => {
        this.setState({
            game: nextGame,
        });
    };
}
